// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import { ModuleItem } from '../components/moduleItem'
import { Message } from '../components/message'
import { Loading } from '../components/loading'
import config from '../config/config.json'
import { getCategoriesString } from '../utils/enUtils.js'

export class ProviderContent extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            modules: [],
            tutorialModules: [],
            foundationalModules: [],
            showPurchaseModal: false,
            paymentMethodButtonVisibility: { display: 'block' },
            confirmPaymentButtonVisibility: { display: 'none' }
        }

        this.path = {
            modules: '/assets/images/Modules/'
        }

        this.init()
        this.getAllModules(this.props.env, config)
        this.prepareModuleItems = this.prepareModuleItems.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            if (storedData.profileType === 'worker') {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    average_strikes: storedData.average_strikes,
                    confirmed: storedData.confirmed,
                    email: storedData.email,
                    gender: storedData.gender,
                    purpose: storedData.purpose,
                    uid: storedData.uid,
                    fname: storedData.fname,
                    lname: storedData.lname,
                    last_active_at: storedData.last_active_at,
                    workers: JSON.parse(storedData.workers),
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleWorkerDataUpdateFromSessionStorage(data)
            }
            else {

                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    id: storedData.uid,
                    admin_first_name: storedData.fname,
                    admin_last_name: storedData.lname,
                    name: storedData.company,
                    address: storedData.address,
                    license_count: storedData.licenseCount,
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleProviderDataUpdateFromSessionStorage(data)
            }
        }
    }

    getAllModules(env, config) {
        fetch(config[env] + config.api.provider_modules.endpoint, {
            method: config.api.provider_modules.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                let modules = responseJson.enabler_modules
                modules.sort((a, b) => (a.name < b.name) ? -1 : 1)

                let tutorialModules = modules.filter(module => {
                    module.category = getCategoriesString(module.category)
                    return module.category.includes(config.consts.MOD_TUTORIAL)
                })

                let foundationalModules = modules.filter(module => {
                    module.category = getCategoriesString(module.category)
                    return module.category.includes(config.consts.MOD_FOUNDATION)
                })

                this.setState({
                    modules,
                    tutorialModules,
                    foundationalModules,
                    loading: false
                })

            })
            .catch((error) => {
                console.error(error)
            })
    }

    prepareModuleItems(modules) {
        return modules.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    category={module.category}
                    summary={module.summary}
                >
                    <Row>
                        <Col sm={12}>
                            <b>Quantity:</b> <span>{module.licence_count}</span>
                        </Col>
                    </Row>
                </ModuleItem>
            )
        })
    }

    prepareModuleListing() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        else if (this.state.modules.length === 0) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message text="You don't have any modules to assign at the moment."></Message>
                    </Col>
                </Row>
            )
        }
        else {
            if (this.state.tutorialModules.length !== 0) {
                if (this.state.foundationalModules.length !== 0) {
                    return (
                        <Row>
                            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                                <section className="tutorial-modules">
                                    <h3 className="category-title">Tutorials</h3>
                                    {this.prepareModuleItems(this.state.tutorialModules)}
                                </section>
                                <section className="foundation-modules">
                                    <h3 className="category-title">Foundation Topics</h3>
                                    {this.prepareModuleItems(this.state.foundationalModules)}
                                </section>
                            </Col>
                        </Row>
                    )
                }
                else {
                    return (
                        <Row>
                            <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                                <section className="tutorial-modules">
                                    <h3 className="category-title">Tutorials</h3>
                                    {this.prepareModuleItems(this.state.tutorialModules)}
                                </section>
                            </Col>
                        </Row>
                    )
                }
            }
            else {
                return (
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <section className="foundation-modules">
                                <h3 className="category-title">Foundation Topics</h3>
                                {this.prepareModuleItems(this.state.foundationalModules)}
                            </section>
                        </Col>
                    </Row>
                )
            }
        }
    }

    render() {
        return (
            <div className="training-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={2}
                    appData={this.props.appData}
                />
                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"provider_content"}
                    profile={0}
                />
                <div className="main-body">
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                <h2 className="title">Organisation Content</h2>
                            </div>
                        </Col>
                    </Row>
                    {this.prepareModuleListing()}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/providerContent.js